module.exports = __webpack_public_path__ + "static/media/vwu_logo.ffe56770.svg";